window.addEventListener('DOMContentLoaded', () => {
    const tabItem = Array.from(document.querySelectorAll('.section-product-a-vita .tab-text-item'));
    const tabWrapper = Array.from(document.querySelectorAll('.tab-wrapper'));
    const mainContent = document.querySelector('#MainContent');
    const modalContainer = document.querySelector('.section-mask-vita550-modal');
    const btn = document.querySelector('.get-more-icon');
    let activeTab = null;
    btn?.addEventListener(
      'click',
      () => {
        mainContent.classList.remove('transition-slide-init');
        mainContent.classList.add('transition-slide-left');
        modalContainer.style.transform = 'translateX(0)';
        document.body.style.overflow = 'hidden';
      },
      false
    );
    $('.mask-close-ward .mask-close').on('click', () => {
      mainContent.classList.remove('transition-slide-left');
      mainContent.classList.add('transition-slide-init');
      modalContainer.style.transform = 'translateX(100%)';
      document.body.style.overflow = 'auto';
    });
    tabItem.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('active');
        activeTab = item;
        updateSlider(item);
      }
      item.addEventListener('click', () => {
        activeTab = item;
        updateSlider(item);
        tabItem.forEach((t) => t.classList.remove('active'));
        item.classList.add('active');
        tabWrapper.forEach((t) => t.classList.remove('tab-wrapper-active'));
        tabWrapper[index].classList.add('tab-wrapper-active');
      });
    });

    $(window).on(
      'resize',
     debounce(() => updateSlider(),150)
    );
    function updateSlider(item) {
      const { offsetLeft, offsetWidth } = item ?? activeTab;
      $('.section-product-a-vita').css({
        ['--offsetLeft']: offsetLeft + 'px',
        ['--offsetWidth']: offsetWidth + 'px',
      });
    }
  });